var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaccination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.471,
    height: 26.766,
    viewBox: "0 0 16.471 26.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vaccination",
    transform: "translate(-1216.571 -105.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M1217.813,123.5l1.1,3.724,3.724-1.1,1.224-2.243-2.008-1.1a.457.457,0,1,1,.438-.8l2.008,1.1.438-.8-1.214-.662a.457.457,0,1,1,.438-.8l1.214.662.877-1.606-2.008-1.1a.457.457,0,1,1,.438-.8l2.008,1.1.438-.8-1.214-.662a.458.458,0,0,1,.438-.8l1.214.663.658-1.205-4.82-2.629-5.386,9.874Z",
    fill: "#ffc524"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1250",
    "data-name": "Rectangle 1250",
    width: 4.575,
    height: 5.49,
    transform: "translate(1223.639 112.819) rotate(-61.385)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M1216.809,132.024a.458.458,0,0,0,.621-.183l1.972-3.615a.444.444,0,0,0,.05-.212l3.621-1.065a.457.457,0,0,0,.272-.219l5.478-10.041h0l3.067-5.622-2.409-1.315.876-1.607,2.008,1.1a.457.457,0,1,0,.438-.8l-5.622-3.068a.457.457,0,1,0-.438.8l2.811,1.534-.876,1.607-3.213-1.753-2.848,5.22h0l-5.7,10.442a.46.46,0,0,0-.038.348l1.278,4.345a.458.458,0,0,0,.22.273l-1.753,3.213A.458.458,0,0,0,1216.809,132.024Zm13.84-20.592-2.191,4.016-4.819-2.629,2.191-4.017Zm-8.016,14.693-3.724,1.1-1.1-3.724,5.386-9.874,4.82,2.629-.657,1.205-1.215-.663a.457.457,0,0,0-.438.8l1.214.663-.438.8-2.008-1.095a.457.457,0,1,0-.438.8l2.008,1.1-.877,1.606-1.214-.662a.457.457,0,0,0-.438.8l1.214.662-.438.8-2.008-1.1a.457.457,0,1,0-.438.8l2.008,1.1Z",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccination);
export default __webpack_public_path__ + "static/media/Vaccination.ec1613f38fbefed9aa8ec9e9de911155.svg";
export { ForwardRef as ReactComponent };